import React from 'react'

interface ArticleImageProps {
	article: { imageGuid?: string | null, imageId?: number | null }
	alt?: string
	className?: string
	type?: 'big' | 'thumbnail' | 'default'
	onClick?: React.MouseEventHandler<HTMLImageElement>
}

export const getImageUrl = (
	article: { imageGuid?: string | null, imageId?: number | null },
	type: 'big' | 'thumbnail' | 'default' = 'big'
): string | null => {
	const baseUrl = process.env['REACT_APP_API_URL']
	const guid = article?.imageGuid
	const imageId = article?.imageId

	if (guid) {
		switch (type) {
			case 'thumbnail':
				return `${baseUrl}/api/ArticleImageThumbnail/${guid}`
			case 'default':
				return `${baseUrl}/api/ArticleImages/${guid}`
			case 'big':
			default:
				return `${baseUrl}/api/ArticleImageBig/${guid}`
		}
	} else if (imageId && imageId > 0) {
		switch (type) {
			case 'thumbnail':
				return `${baseUrl}/api/ArticleImageThumbnail/${imageId}`
			case 'default':
				return `${baseUrl}/api/ArticleImages/${imageId}`
			case 'big':
			default:
				return `${baseUrl}/api/ArticleImageBig/${imageId}`
		}
	}
	return null
}

const ArticleImage: React.FC<ArticleImageProps> = ({
	article,
	alt = 'Product',
	className = '',
	type = 'big',
	onClick,
}) => {
	if (!article?.imageGuid && (!article?.imageId || article.imageId === 0)) return null
	return (
		<img
			src={getImageUrl(article, type) ?? undefined}
			alt={alt}
			className={className}
			onClick={onClick}
		/>
	)
}

export default ArticleImage